<template>
  <div class="page_error">
    <div>
      <v-icon class="error_icon">memory</v-icon>
    </div>
    <div class="error_text">
      <h1>500</h1>
      <h3>Erro interno</h3>
      <p>Há um problema com o recurso que você está procurando, ele não pode ser exibido.</p>
    </div>
  </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>

</style>
